import {AxiosError} from 'axios';
import {get, toString} from 'lodash';
import {ToastContent, ToastOptions, toast} from 'react-toastify';
import {ErrorContainer} from '../../ui/error-container';

export class ToastHelpers {
  private static isAdmin: boolean = false;

  static setIsAdmin(isAdmin: boolean) {
    ToastHelpers.isAdmin = isAdmin;
  }

  static extractTitleFromHtmlError(html: string): string {
    if (!html) return '';
    const cleaned = html.replace(/\s+/g, ' ');
    const match = cleaned.match(/<title>(.*?)<\/title>/i);
    return match ? match[1].trim() : '';
  }

  static getToastParams(
    error: unknown,
    config?: ToastOptions,
  ): {title: string; message: string; options: ToastOptions} {
    let title: string = '';
    let message: string = '';
    let toastId: ToastOptions['toastId'] = config?.toastId;

    if (error instanceof AxiosError) {
      const res = error.response;
      const status = error.response?.status;

      if (status === 401) {
        message = 'Неавторизованный пользователь';
        toastId = 'auth';
      } else {
        title = get(res, 'data.title') || this.extractTitleFromHtmlError(get(res, 'data', ''));
        message = get(res, 'data.message', '');
        const cause = get(res, 'data.cause', '');

        if (ToastHelpers.isAdmin && message !== cause) {
          message += `\n${cause}`
        };
      }
    } else if (error instanceof Error) {
      message = error.message;
    } else if (error) {
      message = toString(error);
    }

    return {
      title,
      message,
      options: {
        autoClose: 30000,
        pauseOnHover: true,
        draggable: false,
        hideProgressBar: true,
        closeOnClick: false,
        containerId: 'error',
        toastId,
      },
    };
  }

  static error(error: unknown, config?: ToastOptions, withoutBackdrop?: boolean): void {
    const {title, message, options} = this.getToastParams(error, config);
    const toastOptions: ToastOptions = {
      ...options,
      data: {
        ...((options.data as Record<string, unknown> | undefined) || {}),
        withoutBackdrop,
      },
    };

    toast(({closeToast}) => <ErrorContainer title={title} message={message} close={closeToast} />, toastOptions);
  }

  static success(message: ToastContent<unknown>, config?: ToastOptions): void {
    toast.success(message, {containerId: 'default', ...config});
  }
}
